<template>
  <div class="login">
    <div class="login-wrap">
      <div class="login_id-pass">
        <div class="btn-back">
          <img
            src="../../assets/img/login/arrow.png"
            alt="前のページに戻る"
            @click="onClickLeft"
          />
        </div>
        <div class="login_input-box two-fac">
          <p class="login_code_title">コードを確認</p>
          <p class="login_code_ex">送信されたコードを入力してください。</p>

          <van-password-input
            :value="authCode"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
            @click="showPopup"
            :gutter="10"
            :length="6"
            :mask="false"
          />
          <van-popup
            v-model:show="keyboard"
            position="bottom"
            :style="{ height: '27%' }"
            :overlay="false"
          >
            <van-number-keyboard
              v-model="authCode"
              v-model:show="keyboard"
              @blur="keyboard = false"
            />
          </van-popup>
        </div>
        <p class="login_pass-lose login_code-lose">
          届かないので<a
            href="javascript:;"
            @click="sendCode"
            :disabled="resendDisabled"
            >再送信する</a
          >
          <span v-if="resendDisabled" class="timer"
            >{{ remainingTime }}秒後に再送信可能</span
          >
        </p>
        <van-button
          style="margin-top: 30px"
          :disabled="this.authCode.length < 6"
          block
          :color="this.authCode.length < 6 ? '#AACBE7' : '#48b2fb'"
          type="primary"
          native-type="submit"
          :loading="loading"
          @click="handleOk"
          id="verification_btn"
        >
          ログイン
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { CheckAuthcode } from "@/services/login";
import { setAuthorization } from "@/utils/request";
import { Login } from "@/services/login";
import { Toast } from "vant";
import "vant/es/toast/style";
import "vant/es/dialog/style";
export default {
  data() {
    return {
      authCode: "",
      showKeyboard: false,
      keyboard: false,
      loginRes: null,
      loading: false,
      resendDisabled: false,
      remainingTime: 0,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.loginRes = JSON.parse(localStorage.getItem("loginAuthoritarian"));
  },
  methods: {
    showPopup() {
      this.keyboard = true;
    },
    onClickLeft() {
      history.back();
    },
    handleOk() {
      this.loading = true;
      const refreshtoken = this.loginRes.data.refreshToken;
      const authCode = this.authCode;
      CheckAuthcode(refreshtoken, authCode).then((res) => {
        if (res.data.code === 0) {
          this.toMain(this.loginRes);
        } else {
          Toast("認証コードエラー");
          this.loading = false;
          return false;
        }
      });
    },
    toMain(data) {
      //用户名密码验证通过之后，保存用户信息 跳转主页
      const { user, refreshToken, token, expireAt } = data.data;
      localStorage.setItem("refreshtoken", refreshToken);
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));

      let expireAt_T = expireAt.replace(' ', 'T');

      setAuthorization({ token: token, expireAt: new Date(expireAt_T) });
      window.location.reload();
    },
    sendCode() {
      if (this.resendDisabled) return;
      this.resendDisabled = true;
      this.remainingTime = 60;
      const timer = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime === 0) {
          clearInterval(timer);
          this.resendDisabled = false;
        }
      }, 1000);
      Login({
        loginid: this.$store.state.loginid,
        password: this.$store.state.password,
        code: this.$store.state.code,
      }).then(this.afterLogin);
    },
    afterLogin(res) {
      this.loading = false;
      this.$toast.clear();
      this.loginRes = {};
      const loginRes = res.data;
      if (loginRes.code >= 0) {
        if (loginRes.code === 1) {
          this.loginRes = loginRes;
          localStorage.setItem("loginAuthoritarian", JSON.stringify(loginRes));
        } else {
          this.toMain(loginRes);
        }
      } else {
        this.error = loginRes.message;
        Toast(this.error);
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
   
   
  
#verification_btn {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
.van-password-input__security li {
  height: 56px;
  background: #fff;
  border: 3px solid #dfe1e4;
  border-radius: 10px;
  box-sizing: border-box;
}
</style>

